import api from './api'

const tourService = {
  // Get all tours
  getAllTours: async (params = {}) => {
    const response = await api.get('/tours', { params })
    return response.data
  },

  // Get featured tours
  getFeaturedTours: async () => {
    const response = await api.get('/tours/featured')
    return response.data
  },

  // Get tour by ID
  getTourById: async (id) => {
    const response = await api.get(`/tours/${id}`)
    return response.data
  },

  // Create tour (admin)
  createTour: async (tourData) => {
    const response = await api.post('/tours', tourData)
    return response.data
  },

  // Update tour (admin)
  updateTour: async (id, tourData) => {
    const response = await api.put(`/tours/${id}`, tourData)
    return response.data
  },

  // Delete tour (admin)
  deleteTour: async (id) => {
    const response = await api.delete(`/tours/${id}`)
    return response.data
  },
}

export default tourService
